import type { KeyboardEvent } from 'react'

/**
 * The hand-over and the return are long forms with fields of their own inside
 * (a document's number, a damage's words, a charge). Enter in any of them would
 * submit the whole form: hand the vehicle over, or close the rental, half done.
 * Only the submit button sends these forms. A file input keeps Enter, which
 * opens the camera; a button keeps it too, being what Enter presses.
 */
export function noImplicitSubmit(event: KeyboardEvent<HTMLFormElement>) {
  const target = event.target
  if (event.key === 'Enter' && target instanceof HTMLInputElement && target.type !== 'file') {
    event.preventDefault()
  }
}
